module.exports = __webpack_public_path__ + "img/9788901093413.ddd42b67.jpg";